import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function TermsOfServicePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-4">
          <Button onClick={() => navigate(-1)} variant="ghost" size="sm">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour
          </Button>
          <h1 className="font-bold text-xl">Conditions Générales d'Utilisation</h1>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-xl shadow-sm p-8 prose prose-slate max-w-none">
          <p className="text-gray-500 mb-8">Dernière mise à jour : 11 mars 2026</p>

          <h2>1. Acceptation des conditions</h2>
          <p>
            En accédant et en utilisant l'application CAISSE MPHONE (le "Service"), vous acceptez 
            d'être lié par ces Conditions Générales d'Utilisation ("Conditions"). Si vous n'acceptez 
            pas ces Conditions, veuillez ne pas utiliser le Service.
          </p>

          <h2>2. Description du Service</h2>
          <p>
            CAISSE MPHONE est une application de gestion commerciale destinée aux professionnels 
            de la réparation de smartphones, tablettes et ordinateurs. Le Service comprend :
          </p>
          <ul>
            <li>Module de caisse pour le suivi des encaissements quotidiens</li>
            <li>Module de facturation (devis et factures)</li>
            <li>Gestion des clients</li>
            <li>Intégration Google Business Profile pour la gestion des avis et publications</li>
            <li>Génération de réponses aux avis par intelligence artificielle</li>
          </ul>

          <h2>3. Inscription et compte</h2>
          <h3>3.1 Création de compte</h3>
          <p>
            Pour utiliser le Service, vous devez créer un compte en fournissant des informations 
            exactes et complètes. Vous êtes responsable de maintenir la confidentialité de vos 
            identifiants de connexion.
          </p>

          <h3>3.2 Sécurité du compte</h3>
          <p>
            Vous êtes responsable de toutes les activités effectuées sous votre compte. Vous 
            devez nous informer immédiatement de toute utilisation non autorisée de votre compte.
          </p>

          <h2>4. Utilisation acceptable</h2>
          <p>Vous vous engagez à :</p>
          <ul>
            <li>Utiliser le Service conformément aux lois et réglementations applicables</li>
            <li>Ne pas utiliser le Service à des fins frauduleuses ou illégales</li>
            <li>Ne pas tenter d'accéder aux systèmes ou données d'autres utilisateurs</li>
            <li>Ne pas transmettre de virus ou code malveillant</li>
            <li>Ne pas surcharger ou perturber le fonctionnement du Service</li>
          </ul>

          <h2>5. Intégration Google Business Profile</h2>
          <p>
            En connectant votre compte Google Business Profile à notre Service, vous nous 
            autorisez à :
          </p>
          <ul>
            <li>Accéder aux informations de votre établissement</li>
            <li>Lire les avis clients</li>
            <li>Publier des réponses aux avis en votre nom</li>
            <li>Créer et gérer des publications</li>
          </ul>
          <p>
            Vous restez responsable de tout contenu publié sur votre fiche Google via notre 
            Service. Nous ne sommes pas responsables des conséquences liées à l'utilisation 
            de l'intégration Google Business Profile.
          </p>

          <h2>6. Intelligence artificielle (IA)</h2>
          <p>
            Notre Service utilise l'intelligence artificielle pour générer des suggestions 
            de réponses aux avis clients. Vous reconnaissez que :
          </p>
          <ul>
            <li>Les réponses générées sont des suggestions que vous devez vérifier avant publication</li>
            <li>Vous êtes responsable du contenu final publié</li>
            <li>L'IA peut parfois générer des réponses inexactes ou inappropriées</li>
            <li>Nous ne garantissons pas la pertinence des réponses générées</li>
          </ul>

          <h2>7. Propriété intellectuelle</h2>
          <p>
            Le Service, y compris son contenu, ses fonctionnalités et son design, est protégé 
            par les lois sur la propriété intellectuelle. Vous ne pouvez pas copier, modifier, 
            distribuer ou créer des œuvres dérivées sans notre autorisation écrite préalable.
          </p>

          <h2>8. Données et sauvegarde</h2>
          <p>
            Bien que nous prenions des mesures raisonnables pour protéger vos données, vous 
            êtes responsable de la sauvegarde de vos propres données. Nous vous recommandons 
            d'exporter régulièrement vos données importantes.
          </p>

          <h2>9. Limitation de responsabilité</h2>
          <p>
            Dans les limites autorisées par la loi, MPHONE ne sera pas responsable des :
          </p>
          <ul>
            <li>Pertes indirectes, accessoires ou consécutives</li>
            <li>Pertes de données ou interruptions d'activité</li>
            <li>Dommages résultant de l'utilisation du Service</li>
            <li>Actions de tiers ou intégrations externes</li>
          </ul>

          <h2>10. Indemnisation</h2>
          <p>
            Vous acceptez d'indemniser et de dégager MPHONE de toute responsabilité en cas 
            de réclamations résultant de votre utilisation du Service ou de votre violation 
            de ces Conditions.
          </p>

          <h2>11. Modifications du Service</h2>
          <p>
            Nous nous réservons le droit de modifier, suspendre ou interrompre le Service 
            à tout moment, avec ou sans préavis. Nous ne serons pas responsables envers 
            vous ou tout tiers pour toute modification, suspension ou interruption du Service.
          </p>

          <h2>12. Modifications des Conditions</h2>
          <p>
            Nous pouvons modifier ces Conditions à tout moment. Les modifications prennent 
            effet dès leur publication. Votre utilisation continue du Service après la 
            publication des modifications constitue votre acceptation des nouvelles Conditions.
          </p>

          <h2>13. Résiliation</h2>
          <p>
            Nous pouvons résilier ou suspendre votre accès au Service immédiatement, sans 
            préavis, pour toute raison, y compris en cas de violation de ces Conditions. 
            Vous pouvez également résilier votre compte à tout moment en nous contactant.
          </p>

          <h2>14. Droit applicable</h2>
          <p>
            Ces Conditions sont régies par le droit français. Tout litige relatif à ces 
            Conditions sera soumis à la compétence exclusive des tribunaux de Lyon, France.
          </p>

          <h2>15. Divisibilité</h2>
          <p>
            Si une disposition de ces Conditions est jugée invalide ou inapplicable, les 
            autres dispositions resteront en vigueur.
          </p>

          <h2>16. Contact</h2>
          <p>Pour toute question concernant ces Conditions, contactez-nous :</p>
          <ul>
            <li><strong>Email</strong> : kophonelab@gmail.com</li>
            <li><strong>Adresse</strong> : 5 Rue Paul Verlaine, 69100 Villeurbanne, France</li>
            <li><strong>Téléphone</strong> : 04 78 XX XX XX</li>
          </ul>

          <div className="mt-8 p-4 bg-gray-100 rounded-lg">
            <p className="text-sm text-gray-600 m-0">
              En utilisant CAISSE MPHONE, vous confirmez avoir lu, compris et accepté ces 
              Conditions Générales d'Utilisation.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
